// extracted by mini-css-extract-plugin
export default {"GiftGiverInfoForm__SubmitButton":"GiftGiverInfoForm-styles__GiftGiverInfoForm__SubmitButton__njDw8"};